<template>
  <tr class="document-type-list__card" :class="{complete: status == 'complete', error: status == 'error'}">
    <td data-title="Название">
      <input type="text" v-model="item.label">
    </td>
    <td data-title="Активность">
      <input type="checkbox" class="checkbox-toggler" v-model="item.active" :id="`active-${item.id}`">
      <label :for="`active-${item.id}`"></label>
    </td>
    <td data-title="Сортировка">
      <input type="number" v-model.number="item.sort">
    </td>
    <td data-title="Время выполнения (мин)" class="document-type-list__time-row">
      <div class="document-type-list__time">
        <div class="form__row form__row--floating" v-for="urgency in urgencies" :key="urgency.id">
          <input
            type="number"
            v-model.number="urgency.time"
            min="0"
          >
          <label>{{ urgency.name }}</label>
        </div>
      </div>
    </td>
    <td class="text-right document-type-list__check-btn">
      <button
        type="button"
        class="button-check"
        @click="onSave"
        :disabled="status == 'pending'"
      ></button>
    </td>
  </tr>
</template>

<script>
export default {
  data: function() {
    return {
      item: this.data,
      urgencies: [],
      status: null
    };
  },

  props: {
    data: {
      type: Object,
      require: true
    },
    urgencyData: {
      type: Array,
      required: true
    }
  },

  methods: {
    update: function() {
      const t = this;
      axios
        .put("/doc-type/" + this.item.id, {
          label: this.item.label,
          active: this.item.active,
          sort: this.item.sort,
          urgency: this.urgencies
        })
        .then(function() {
          t.status = "complete";
        })
        .catch(function(error) {
          t.status = "error";
          console.error(error);
        });
    },

    onSave: function(item) {
      this.status = "pending";
      this.update();
    },

    mergeUrgency: function() {
      const t = this;

      for (var i = 0; i < this.urgencyData.length; i++) {
        let result = _.find(this.data.urgency, function(o) {
          return o.id == t.urgencyData[i].id;
        });
        if (result) {
          const urgencyObj = {
            id: this.urgencyData[i].id,
            name: this.urgencyData[i].name,
            time: result.pivot.time
          };
          this.urgencies.push(urgencyObj);
        } else {
          const urgencyObj = {
            id: this.urgencyData[i].id,
            name: this.urgencyData[i].name,
            time: 0
          };
          this.urgencies.push(urgencyObj);
        }
      }
    }
  },

  watch: {
    urgencies: {
      handler: function(e) {
        _.forEach(e, function(value) {
          if (value.time < 0) value.time = 0;
        });
      },
      deep: true
    }
  },

  mounted() {
    this.mergeUrgency();
  }
};
</script>

<style scoped>
.error {
  animation: error 1s 1 ease-in-out;
}

.complete {
  animation: complete 1s 1 ease-in-out;
}

@keyframes error {
  from {
    background-color: #f2dede;
  }
  to {
    background-color: transparent;
  }
}
@keyframes complete {
  from {
    background-color: #dff0d8;
  }
  to {
    background-color: transparent;
  }
}
</style>
